// eslint-disable-next-line
export default (price: number, rabat: number) =>
  Math.ceil((price * 100 * (100 - rabat)) / 100) / 100;
